import React, { useImperativeHandle, useRef, useState } from "react";


import { CenteredForm, GlobalStyle, StyledContainerRow, StyledFormStretched, StyledLabel, } from "./TrunkFormRefactored.styles";

import { SelectPicker } from "rsuite";
import Form from "components/Form/CompatForm";

const IvrFormSection = ({ formRef, isMobile, ivr_list, disabled, initialValues }) => {
    const form = useRef(null);
    const ivrData = ivr_list.map(ivr => {
        return {
            value: ivr.id,
            label: ivr.name
        };
    });
    const emptyIvr = {
        value: null,
        label: ""
    };

    const [currentIvr, setCurrentIvr] = useState(initialValues.ivr_id);
    const [formValue, setFormValue] = useState({ ...initialValues });

    useImperativeHandle(formRef, () => ({
        check: (...args) => form.current?.check(...args),
        getFormValue: () => formValue,
        root: form.current?.root || null
    }), [formValue]);

    const sortedIvrList = [...ivrData, emptyIvr];
    sortedIvrList.sort((a, b) => {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
    });

    return (
        <>
            <GlobalStyle />
            <CenteredForm
                ref={form}
                formDefaultValue={{ ...initialValues }}
                formValue={formValue}
                onChange={setFormValue}
                style={{ width: "100%" }}
            >
                <StyledFormStretched>
                    <div className="column">
                        <StyledContainerRow>
                            <StyledLabel display="block" compact width={100}>Select IVR</StyledLabel>
                            <Form.Control
                                className="ivr_select"
                                accepter={SelectPicker}
                                data={sortedIvrList}
                                name="ivr_id"
                                onChange={(value) => {
                                    setCurrentIvr(value);
                                    setFormValue(currentValue => ({
                                        ...currentValue,
                                        ivr_id: value
                                    }));
                                }}
                                value={currentIvr}
                                disabled={disabled}
                                cleanable={false}
                                placement={isMobile ? "topEnd" : "bottomStart"}
                                placeholder={<>&#8203;</>}
                                {...(!isMobile ? { width: 300 } : {})}
                            />
                        </StyledContainerRow>
                    </div>
                </StyledFormStretched>
            </CenteredForm>
        </>
    );
};

export default IvrFormSection;
